<template>
<div class="w-full md:w-1/3 bg-white min-h-full px-4 md:px-7 py-3 md:py-6">

    <div>
        <div class="flex justify-between items-center">
            <div class="flex">
                <div class="font-medium md:font-base text-sm md:text-base">컬럼 검색</div>
                <!-- <button data-popover-target="col-popover" data-popover-placement="bottom" type="button">ⓘ</button>
                <div data-popover id="col-popover" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-96">
                    <div class="p-3 space-y-2">
                        <h4 class="font-medium text-black">Datamap Search는 데이터세트의 컬럼 정보까지 수집합니다.</h4>
                        <p>한번에 여러 개의 컬럼을 검색할 수 있고, 가장 많이 사용된 컬럼을 자동완성 단어로 추천하여 편리한 검색 기능을 제공합니다.</p>
                    </div>
                    <div data-popper-arrow></div>
                </div>   -->
                <div class="hidden md:block">
                    <Popper arrow hover>
                        <span>ⓘ</span>
                        <template #content>
                            <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                                <h4 class="font-medium text-black">Datamap Search는 데이터세트의 컬럼 정보까지 수집합니다.</h4>
                                <p>한번에 여러 개의 컬럼을 검색할 수 있고, 가장 많이 사용된 컬럼을 자동완성 단어로 추천하여 편리한 검색 기능을 제공합니다.</p>
                            </div>
                        </template>
                    </Popper>  
                </div>
            </div>
            <div class="flex">
                <button type="reset" class="text-xs md:text-sm underline pl-3" @click="resetColumnSearch">Reset</button>
                <!-- <button type="button" class="text-sm underline pl-3" @click="columnSearch">Apply</button> -->
            </div>
        </div>
        <form @submit.prevent="formSubmit" class="w-full drop-shadow-sm pt-4">
            <input ref="input" :value="searchInput" type="text" @input="[searchInput = $event.target.value, submitAutoComplete()]"
                placeholder="특정 컬럼이 포함된 데이터세트를 검색해보세요." 
                class="w-full focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-2 py-2.5 px-4 text-xs md:text-sm bg-zinc-100 outline-none border-none" />

                <!-- 자동완성 추가 - click하면 searchInputList로 넘어가도록 수정.. -->
                <ul v-if="this.searchInput" ref="list" class="bg-white mt-0.5 p-1 w-full border border-gray-400 text-xs md:text-sm" style="position:absolute; z-index: 2;">
                    <li class="p-1 hover:bg-zinc-100" v-for="(res,i) in result" :key="i" @click="autoCompleteData(res)" >
                        <!-- <span :value=autoCompleteWord @click="(searchInput=autoCompleteWord)">{{ res }}</span> -->
                        <span>{{ res }}</span>
                    </li>
                </ul>

            <div v-if="this.searchInputList.length > 0" class="mt-3">
                <div v-for="(column, idx) in this.searchInputList" v-bind:key="idx" 
                    class="inline-flex items-center py-1 px-2 mr-2 mb-2 text-xs md:text-sm font-medium text-blue-800 bg-blue-100 rounded">
                    {{ column }}
                    <button ref="button" type="button" @click="removeColumn(idx)" 
                        class="inline-flex items-center p-0.5 ml-2 text-xs md:text-sm text-blue-400 bg-transparent rounded-sm hover:bg-blue-200 hover:text-blue-900">
                        <XMarkIcon class="w-4 h-4" />
                    </button>
                </div>
            </div>

            <!-- <div class="mt-5">
                <div class="text-sm font-medium mb-3 text-gray-600">추천 컬럼명</div>
                <button v-for="(col, idx) in this.recomColsList" v-bind:key="idx" type="button" @click="(autoCompleteData(col.key), removeRecommend(idx))"
                    class="inline-flex items-center py-1 px-2 mr-2 mb-2 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                    {{ col.key }}
                </button>
            </div> -->
            <!-- <div v-else class="mt-5">
                <div class="text-sm font-medium mb-3 text-gray-600">추천 컬럼명</div>
                <button v-for="(col, idx) in this.newRecomColsList" v-bind:key="idx" type="button" @click="(autoCompleteData(col.key), removeRecommend(idx))"
                    class="inline-flex items-center py-1 px-2 mr-2 mb-2 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                    {{ col.key }}
                </button>
            </div> -->


        </form>
    </div>

    <div>
        <!-- 포털 facet -->
        <div class="flex justify-between items-center pt-6"> 
            <div class="hidden md:flex">
                <div class="pr-2">포털 적용</div>
                <!-- <button data-popover-target="portal-popover" data-popover-placement="bottom" type="button">ⓘ</button>
                <div data-popover id="portal-popover" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-96 ">
                    <div class="p-3 space-y-2">
                        <h4 class="font-medium text-black">데이터세트를 개방하는 포털을 기준으로 탐색할 수 있습니다.</h4>
                        <p>국내 여러 데이터포털에세 제공하는 산재된 데이터세트를 수집하여 한 곳에서 검색할 수 있습니다.</p>
                    </div>
                    <div data-popper-arrow></div>
                </div>   -->

                <Popper arrow hover>
                    <span>ⓘ</span>
                    <template #content>
                        <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                            <h4 class="font-medium text-black">데이터세트를 개방하는 포털을 기준으로 탐색할 수 있습니다.</h4>
                            <p>국내 여러 데이터포털에세 제공하는 산재된 데이터세트를 수집하여 한 곳에서 검색할 수 있습니다.</p>
                        </div>
                    </template>
                </Popper>  
            </div>
            <div class="flex md:hidden justify-center items-center">
                <div class="pr-2 text-sm font-medium">포털 적용</div>
                <button v-if="this.facetPltStatus == false" @click="facetPltOnOff">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
                <button v-if="this.facetPltStatus == true" @click="facetPltOnOff">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>
                </button>
            </div>
            <div class="flex">
                <button type="reset" class="text-xs md:text-sm underline pl-3" @click="resetPtl">Reset</button>
                <button type="button" class="text-xs md:text-sm underline pl-3" @click="sendFacet">Apply</button>
            </div>
        </div>
        <div class="hidden md:flex">
            <div v-if="this.model.ptlList.length !== 0" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-sm w-full">
                <label v-for="(item, idx) in this.model.ptlList" v-bind:key="idx" class="flex pb-3 justify-between">
                    <!-- <Popper arrow hover>
                        <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                        <template #content>
                            <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                                <div>{{ portalData[item.key[0]]['des'] }}</div>
                                <div>&#8226; 총 데이터 보유 수량: {{ portalData[item.key[0]]['numDataset'] }}건</div> 
                                <div>&#8226; 데이터 제공기관 수: {{ portalData[item.key[0]]['numOrg'] }}개</div>
                            </div>
                        </template>
                    </Popper>   -->
                    <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                    <input ref="checkbox" type="checkbox" 
                        :value="item.key[0]" v-model="ptlChk" 
                        class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                </label>
            </div>
        </div>
        <div v-if="this.facetPltStatus == true"  class="flex md:hidden">
            <div v-if="this.model.ptlList.length !== 0" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-xs md:text-sm w-full">
                <label v-for="(item, idx) in this.model.ptlList" v-bind:key="idx" class="flex pb-1.5 justify-between">
                    <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                    <input ref="checkbox" type="checkbox" 
                        :value="item.key[0]" v-model="ptlChk" 
                        class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                </label>
            </div>
        </div>
        <!-- 기관 facet -->
        <div class="flex justify-between items-center pt-6">
            <div class="hidden md:flex">
                <div class="pr-2">기관 적용</div>
                <!-- <button data-popover-target="org-popover" data-popover-placement="bottom" type="button">ⓘ</button>
                <div data-popover id="org-popover" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-96">
                    <div class="p-3 space-y-2">
                        <h4 class="font-medium text-black">데이터세트를 제공하는 기관을 기준으로 탐색할 수 있습니다.</h4>
                        <p>한 기관이 여러 개의 데이터포털에 데이터를 제공할 수 있습니다. Datamap Search는 제공기관을 기준으로 데이터세트를 의미적으로 연결하여, 데이터포털의 경계를 넘는 검색을 할 수 있습니다.</p>
                    </div>
                    <div data-popper-arrow></div>
                </div>   -->

                <Popper arrow hover>
                    <span>ⓘ</span>
                    <template #content>
                        <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                            <h4 class="font-medium text-black">데이터세트를 제공하는 기관을 기준으로 탐색할 수 있습니다.</h4>
                            <p>한 기관이 여러 개의 데이터포털에 데이터를 제공할 수 있습니다. Datamap Search는 제공기관을 기준으로 데이터세트를 의미적으로 연결하여, 데이터포털의 경계를 넘는 검색을 할 수 있습니다.</p>
                        </div>
                    </template>
                </Popper>  

            </div>
            <div class="flex md:hidden justify-center items-center">
                <div class="pr-2 text-sm font-medium">기관 적용</div>
                <button v-if="this.facetOrgStatus == false" @click="facetOrgOnOff">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
                <button v-if="this.facetOrgStatus == true" @click="facetOrgOnOff">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>
                </button>
            </div>
            <div class="flex">
                <button type="reset" class="text-xs md:text-sm underline pl-3" @click="resetOrg">Reset</button>
                <button type="button" class="text-xs md:text-sm underline pl-3" @click="sendFacet">Apply</button>
            </div>
        </div>
        <div class="hidden md:block">
            <div v-if="isStatusOn" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-sm">
                <label v-for="(item, idx) in this.model.orgList.slice(0,15)" v-bind:key="idx" class="flex pb-3 justify-between">
                    <!-- <Popper arrow hover>
                        <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                        <template #content>
                            <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                                <div v-if="(orgData[item.key[0]]['des'] !== null)">{{ orgData[item.key[0]]['des'] }}</div> 
                                <div v-if="(orgData[item.key[0]]['url'] !== null)" style="text-transform :lowercase">웹 사이트: {{ orgData[item.key[0]]['url'] }}</div>
                                <div v-if="(orgData[item.key[0]]['address'] !== null)">주소: {{ orgData[item.key[0]]['address'] }}</div>
                                <div v-if="(orgData[item.key[0]]['datasetCount'] !== null)">총 데이터 제공 수량: {{ orgData[item.key[0]]['datasetCount'] }}건</div>
                            </div>
                        </template>
                    </Popper> -->
                    <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                    <input ref="checkbox" type="checkbox" :value="item.key[0]" v-model="orgChk" class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                </label>
                <button v-if="this.model.orgList.length > 15" @click="buttonOnOff" class="w-full bg-white py-2 my-3 border">더 보기</button>
            </div>
            <div v-if="isStatusOff" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-sm">
                <label v-for="(item, idx) in this.model.orgList" v-bind:key="idx" class="flex pb-3 justify-between">
                    <!-- <Popper arrow hover>
                        <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                        <template #content>
                            <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                                <div v-if="(orgData[item.key[0]]['des'] !== null)">{{ orgData[item.key[0]]['des'] }}</div> 
                                <div v-if="(orgData[item.key[0]]['url'] !== null)" style="text-transform :lowercase">웹 사이트: {{ orgData[item.key[0]]['url'] }}</div>
                                <div v-if="(orgData[item.key[0]]['address'] !== null)">주소: {{ orgData[item.key[0]]['address'] }}</div>
                                <div v-if="(orgData[item.key[0]]['datasetCount'] !== null)">총 데이터 제공 수량: {{ orgData[item.key[0]]['datasetCount'] }}건</div>
                            </div>
                        </template>
                    </Popper> -->
                    <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                    <input ref="checkbox" type="checkbox" :value="item.key[0]" v-model="orgChk" class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                </label>
                <button @click="buttonOnOff" class="w-full bg-white py-2 my-3 border">접기</button>
            </div>
        </div>
        <div class="block md:hidden">
            <div v-if="this.facetOrgStatus == true" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-xs md:text-sm">
                <label v-for="(item, idx) in this.model.orgList.slice(0,15)" v-bind:key="idx" class="flex pb-1.5 justify-between">
                    <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                    <input ref="checkbox" type="checkbox" :value="item.key[0]" v-model="orgChk" class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                </label>
            </div>
        </div>
        <!-- 분류체계 facet -->
        <div class="flex justify-between items-center pt-6">
            <div class="hidden md:flex">
                <div class="pr-2">분류체계 적용</div>
                <!-- <button data-popover-target="cate-popover" data-popover-placement="bottom" type="button">ⓘ</button>
                <div data-popover id="cate-popover" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-96">
                    <div class="p-3 space-y-2">
                        <h4 class="font-medium text-black">통합된 분류체계를 기준으로 데이터세트를 탐색할 수 있습니다.</h4>
                        <p>국내 데이터 포털은 서로 다른 분류체계명을 사용합니다. Datamap Search는 공공데이터포털의 분류체계를 중심으로 서로 다른 포털의 분류체계를 통합하여 검색이 가능합니다.</p>
                    </div>
                    <div data-popper-arrow></div>
                </div>   -->

                <Popper arrow hover>
                    <span>ⓘ</span>
                    <template #content>
                        <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                            <h4 class="font-medium text-black">통합된 분류체계를 기준으로 데이터세트를 탐색할 수 있습니다.</h4>
                            <p>국내 데이터 포털은 서로 다른 분류체계명을 사용합니다. Datamap Search는 공공데이터포털의 분류체계를 중심으로 서로 다른 포털의 분류체계를 통합하여 검색이 가능합니다.</p>
                        </div>
                    </template>
                </Popper>  

            </div>
            <div class="flex md:hidden justify-center items-center">
                <div class="pr-2 text-sm font-medium">분류체계 적용</div>
                <button v-if="this.facetCateStatus == false" @click="facetCateOnOff">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
                <button v-if="this.facetCateStatus == true" @click="facetCateOnOff">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>
                </button>
            </div>
            <div class="flex">
                <button type="reset" class="text-xs md:text-sm underline pl-3" @click="resetCate">Reset</button>
                <button type="button" class="text-xs md:text-sm underline pl-3" @click="sendFacet">Apply</button>
            </div>
        </div>
        <div class="hidden md:block">
            <div v-if="this.model.ctList.length !== 0" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-sm">
                <label v-for="(item, idx) in this.model.ctList" v-bind:key="idx" class="flex pb-3 justify-between">
                    <!-- <Popper arrow hover content="(contents)" id="popover">
                        <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                        <template #content>
                            <div class="text-sm font-light text-gray-500  bg-white border border-gray-200 rounded-lg w-80 p-3 space-y-2">
                                <div>{{ categoryData[item.key[0]]['des'] }}</div>
                                <div v-if="(categoryData[item.key[0]]['ptl1'] !== null)">{{ categoryData[item.key[0]]['ptl1'] }}</div>
                                <div v-if="(categoryData[item.key[0]]['ptl2'] !== null)">{{ categoryData[item.key[0]]['ptl2'] }}</div>
                                <div v-if="(categoryData[item.key[0]]['ptl3'] !== null)">{{ categoryData[item.key[0]]['ptl3'] }}</div>
                            </div>
                        </template>
                    </Popper> -->
                    <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                    <input ref="checkbox" type="checkbox" :value="item.key[0]" v-model="cateChk" 
                        class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                </label>
            </div>
        </div>
        <div class="block md:hidden">
            <div v-if="this.facetCateStatus == true">
                <div v-if="this.model.ctList.length !== 0" class="bg-zinc-100 pt-5 px-5 pb-2 mt-4 text-xs md:text-sm">
                    <label v-for="(item, idx) in this.model.ctList" v-bind:key="idx" class="flex pb-1.5 justify-between">
                        <span>{{ item.key[1] }} | {{ item.doc_count.toLocaleString('ko-KR') }}건</span>
                        <input ref="checkbox" type="checkbox" :value="item.key[0]" v-model="cateChk" 
                            class="ml-1 w-4 h-4 text-sky-500 bg-zinc-100 rounded border-gray-300 focus:ring-sky-500 focus:outline-none focus:ring-2" />
                    </label>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="flex justify-between items-center pt-6">
        <div class="">등록일자 ⓘ</div>
        <div class="text-sm  underline">Apply</div>
    </div>
    <div class="flex items-center pt-4 text-sm">
        <div class="pr-2 w-1/6">From: </div>
        <input class="px-3 py-1.5 w-full bg-zinc-100 focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-2 ibm" type="text" placeholder="yyyy-mm-dd">
    </div>
    <div class="flex items-center pt-2 text-sm">
        <div class="pr-2 w-1/6">To: </div>
        <input class="px-3 py-1.5 w-full bg-zinc-100 focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-2 ibm" type="text" placeholder="yyyy-mm-dd">
    </div> -->
    <!-- <div class="flex justify-between items-center pt-6">
        <div class="">주소 데이터 포함 ⓘ</div>
        <div class="text-sm  underline">Apply</div>
    </div> -->

</div>

</template>

<script>
// import _debounce from 'lodash/debounce'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import Popper from "vue3-popper";
import data from "@/assets/refined-columns-list.json"
import portal from "@/assets/portal.json"
import org from "@/assets/org-1130.json"
import category from "@/assets/cate-1130.json"
// import { get } from 'http';

const columnData = data['columns'];
const portalData = portal;
const orgData = org;
const categoryData = category;

export default {
    name: "FacetView",
    components: {
        XMarkIcon, 
        Popper
    },
    props: {
        model: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            facetPltStatus: false,
            facetOrgStatus: false,
            facetCateStatus: false,
            ptlChk: [],
            orgChk: [],
            cateChk: [],
            isStatusOn: true,
            isStatusOff: false,
            searchInput: "",
            searchInputList: [],
            columnData,
            portalData,
            orgData,
            categoryData,
            result: null,
            // newRecomColsList: [],
            // recomColsList: [],
            // recomColsLen: 10,
        }
    },
    // mounted() {
    //     console.log(this.model)
    // },
    watch: {
        // ptlChk: _debounce(async function() {
        //     await this.sendFacet()
        // }, 250),
        // orgChk: _debounce(async function() {
        //     await this.sendFacet()
        // }, 250),
        // cateChk: _debounce(async function() {
        //     await this.sendFacet()
        // }, 250),
    },
    mounted () {
        this.facetOpen = 0
        // if (this.result.length) {
        // this.$refs.input.focus()
        // this.focused = true
        // }
    },
    methods: {
        buttonOnOff() {
            this.isStatusOn = !this.isStatusOn
            this.isStatusOff = !this.isStatusOff
        },
        facetPltOnOff(){
            this.facetPltStatus = !this.facetPltStatus
        },
        facetOrgOnOff(){
            this.facetOrgStatus = !this.facetOrgStatus
        },
        facetCateOnOff(){
            this.facetCateStatus = !this.facetCateStatus
        },
        // removeRecommend(idx) {
            // let newRecomColsList = null
            // this.recomColsList = idx
            // this.recomColsLen -= 1
            // console.log("빠지고 난 후 데이터", this.recomColsList )
            // let data = {
            //     ptl: this.ptlChk, 
            //     org: this.orgChk,
            //     cate: this.cateChk,
            //     col: newRecomColsList,
            // }
            // this.$emit("columnSearchEvent", data, this.model.page)
            // return this.recomColsList 

            // recomColsList = recomColsList.filter((item, index) => {
            //     return index !== idx
            // })
            // return recomColsList
        // },
        
        autoCompleteData(res){
            // console.log(res)
            this.searchInputList.push(res)
            this.searchInput = ""
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            this.$emit('columnSearchEvent', data, this.model.page)
        },
        formSubmit(e){
            // console.log(this.searchInput)
            this.searchInputList.push(this.searchInput)
            this.searchInput = ""
            // console.log(this.searchInputList)
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            // this.searchInputList = []
            this.$emit('columnSearchEvent', data, this.model.page)
            e.preventDefault()
        },
        submitAutoComplete() {
            if (this.searchInput) {
                this.temp = columnData.filter((skill) => {
                return skill.match(new RegExp("^" + this.searchInput, "i"));
                });
                this.result = this.temp.splice(0, 10)
            } 
        },
        removeColumn(idx){
            this.searchInputList.splice(idx,1)
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            // this.searchInputList = []
            this.$emit('columnSearchEvent', data, this.model.page)
        },
        resetColumnSearch() {
            this.searchInputList = []
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            this.$emit('resetColumnSearchEvent', data, this.model.page)
        },
        resetPtl() {
            this.ptlChk = []
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            this.$emit("resetPtlEvent", data, this.model.page);
        },
        resetOrg() {
            this.orgChk = []
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            this.$emit("resetOrgEvent", data, this.model.page);
        },
        resetCate() {
            this.cateChk = []
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            this.$emit("resetCateEvent", data, this.model.page);
        },
        sendFacet() {
            // console.log("facet에서 보낼 페이지는 ", this.model.page)
            let data = {
                ptl: this.ptlChk, 
                org: this.orgChk,
                cate: this.cateChk,
                col: this.searchInputList,
            }
            this.$emit("facetData", data, this.model.page)
        },
    }
}

</script>

<style scoped>

</style>